module.exports = "<toolbar active=\"HTML\"></toolbar>\n\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-xs-6 col-md-offset-3\">\n        \t<br>\n       \t\t<div ui-ace=\"{\n       \t\t\tonLoad : htmlSourceCtrl.aceLoaded,\n       \t\t\tworkerPath: '/assets/scripts/',\n       \t\t\tmode: 'html'\n       \t\t}\" ng-model=\"htmlSourceCtrl.formhtml\"></div>\n        </div>\n    </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/create/html-source/html-source.html
// module id = 331
// module chunks = 0